import { showContextMenu } from './ContextMenu.js';
import { placeMode } from './PlaceMode.js';

// Max pointer travel (screen px) between down and up to still count as a tap, not a drag.
const TAP_SLOP = 12;

// Tap a placed item → open its context menu (Przesuń / Schowaj, + Garderoba for szafa).
// Tap works on both desktop and touch (unlike right-click). Ignored while placing or
// moving so the tap that drops doesn't also reopen a menu. A drag (e.g. directly
// repositioning a garden/yard decoration) is NOT a tap, so the menu doesn't pop after
// a drag ends.
export function attachPlacementMenu(scene, sprite, placement) {
  sprite.on('pointerup', (pointer) => {
    if (placeMode.active) return;
    // pointer.up/down are canvas px; the retina camera zoom makes them 2x world, so
    // divide by zoom before comparing against the world-unit TAP_SLOP.
    const zoom = scene.cameras.main.zoom || 1;
    const moved = Math.hypot(pointer.upX - pointer.downX, pointer.upY - pointer.downY) / zoom;
    if (moved > TAP_SLOP) return;  // it was a drag, not a tap
    showContextMenu(scene, pointer.worldX, pointer.worldY, placement);
  });
}
